<template>
  <svg 
    v-if="iconContent"
    v-html="iconContent"
    :viewBox="viewBox"
    :width="props.size"
    :height="props.size"
    fill="currentColor"
    :class="['icon', { 'icon--interactive': props.interactive }]"
  />
</template>

<script setup lang="ts">
import { ref, onMounted, defineProps, withDefaults, watch } from 'vue'

const props = withDefaults(defineProps<{
  name: string
  size?: number
  interactive?: boolean
}>(), {
  size: 24,
  interactive: false
})

const iconContent = ref('')
const viewBox = ref('0 0 24 24')

async function loadIcon() {
  try {
    const iconModule = await import(`@/assets/icons/${props.name}.svg?raw`)
    const svgText = iconModule.default
    // Extraire uniquement le contenu à l'intérieur du svg
    const content = svgText.match(/<svg[^>]*>([\s\S]*?)<\/svg>/)?.[1] || ''
    iconContent.value = content
    // Certaines icônes (map-pin) n'ont pas un viewBox 24x24 : sans le leur, le tracé est tronqué
    viewBox.value = svgText.match(/viewBox="([^"]+)"/)?.[1] || '0 0 24 24'
  } catch (error) {
    console.error(`Failed to load icon: ${props.name}`, error)
  }
}

onMounted(() => {
  loadIcon()
})

// Recharger l'icône quand le nom change
watch(() => props.name, () => {
  loadIcon()
})
</script>

<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
  color: var(--text-defaut);
}

.icon--interactive {
  cursor: pointer;
  transition: color 0.2s ease;
}

.icon--interactive:hover {
  color: var(--text-defaut-emphasis);
}
</style>
